import { useMutation, useQuery } from '@tanstack/react-query';
import api from '@api/http/api';

export interface MarketListing {
  id: string;
  key: string;
  price: number;
  amount: number;
  endsAt: string;
  user: {
    username: string;
    id: string;
  };
};

export function useCreateListingMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { amount: number; price: number; key: string; }
  >({
    mutationFn: (values) => api.post('/trading/listings', values),
  });
}

export function useInstantSellMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { amount: number; key: string; }
  >({
    mutationFn: (values) => api.post('/trading/instant-sell', values),
  });
}

export function useEditListingMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { price: number; id: string; }
  >({
    mutationFn: (values) => api.post('/trading/edit-listing', values),
  });
}

export function useBuyListingMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { amount: number; id: string; }
  >({
    mutationFn: (values) => api.post('/trading/buy', values),
  });
}

export function useDeleteListingMutation() {
  return useMutation<{ success: true }, { error: string }, { id: string }>({
    mutationFn: (values) => api.delete(`/trading/listings/${values.id}`),
  });
}

export function useTradingListingsQuery() {
  return useQuery<MarketListing[]>({
    queryFn: () => api.get('/trading/listings'),
    queryKey: ['tradingListings'],
  });
}
